/**
 * Audit Timeline Component
 * 
 * Displays a chronological timeline of audit entries
 */

import type { AuditEntry } from '@/types/audit';
import { AuditEntryCard } from './AuditEntryCard';
import { ScrollArea } from '@/components/ui/scroll-area';

interface AuditTimelineProps {
  entries: AuditEntry[];
}

export function AuditTimeline({ entries }: AuditTimelineProps) {
  if (entries.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <div className="text-4xl mb-2">📋</div>
        <p>No audit history available</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <span className="text-xl">🕐</span>
        <h3 className="text-lg font-semibold">Timeline</h3>
        <span className="text-sm text-muted-foreground">
          ({entries.length} {entries.length === 1 ? 'entry' : 'entries'})
        </span>
      </div>
      
      <ScrollArea className="h-[400px] pr-4">
        <div className="space-y-0">
          {entries.map((entry) => (
            <AuditEntryCard key={entry.id} entry={entry} />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
